import styles from './FacultyProfile.module.css';

interface FacultyProfileProps {
  initials: string;
  name: string;
  role: string;
}

export function FacultyProfile({ initials, name, role }: FacultyProfileProps) {
  return (
    <article className={styles.profile}>
      <span aria-hidden="true" className={styles.avatar}>
        {initials}
      </span>
      <div className={styles.copy}>
        <h3 className={styles.name}>{name}</h3>
        <p className={styles.role}>{role}</p>
      </div>
    </article>
  );
}
